/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Page } from '../../models/page';
import { PageApiRespModel } from '../../models/page-api-resp-model';

export interface ApiMasterPageEditPost$Params {
      body?: Page
}

export function apiMasterPageEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterPageEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PageApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPageEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageApiRespModel>;
    })
  );
}

apiMasterPageEditPost.PATH = '/api/Master/Page/Edit';
